import { TemplateResult, LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-featured-content-block.encapsulated.pcss?inline';
import globalStyles from './styles/outline-featured-content-block.global.pcss?inline';
import '../outline-scaling-grid/outline-scaling-grid';

/**
 * Outline Featured Content Block component
 * 
 * @slot heading - The heading of the featured content block
 * @slot description - The description of the featured content block
 * @slot content - The content of the featured content block
 */

@customElement('outline-featured-content-block')
export class OutlineFeaturedContentBlock extends LitElement {
  
    adoptedStyleSheets = new AdoptedStyleSheets(this, {
        encapsulatedCSS: encapsulatedStyles,
        globalCSS: globalStyles,
    });    

    render(): TemplateResult {
        return html`
            <div class='header-container'>
                <slot name="heading"></slot>
                <slot name="description"></slot>
            </div>
            <div class="wrapper">
                <slot name="content"></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'outline-featured-content-block': OutlineFeaturedContentBlock;
    }
}